import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { RenewalState } from '@ren/main/state/reducers/renewal.reducer';
import { ERRORS_LOAD_POLICY_FAILED } from '@app/infrastructure/constants';
import { selectPolicyId } from '@ren/main/state/selectors/renewal.selectors';

@Injectable({
  providedIn: 'root',
})
export class RouteActivateGuard implements CanActivate {
  constructor(private router: Router, private store: Store<RenewalState>) {}

  checkForPolicy() {
    return this.store.pipe(
      select(selectPolicyId),
      concatMap((data) => {
        if (data === 'NA') {
          this.router.navigate([ERRORS_LOAD_POLICY_FAILED]);
        }
        return of(true);
      })
    );
  }

  canActivate(): boolean | any {
    return this.checkForPolicy().pipe(map((policy) => policy));
  }
}
